import environnements from '@/config/firebase/firebaseConfig'
import { initializeApp } from 'firebase/app'

let config = environnements.dev

const app = initializeApp(config)

export default app
